package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2025_02_15_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2025-02-15")
@Composable
public fun Log_2025_02_15(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Identity Theft",
        ogTitle = "Identity Theft",
        date = LocalDate(2_025, 2, 15),
        ogDescription = "Do’shara the blue dragon assumes the identity of Samuel Thardos Duke of Brij, fooling his guards and subjects for years.",
        ogImage = "ai/2025-02-15.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-74", dateString = "Newgrowth 74")
        Log_2025_02_15_Day_1()
    }
}
